/* eslint-disable @typescript-eslint/no-namespace */
import api from '@/utils/api';
import type { languagesEnum } from '@/utils/consts';
// import Url from "@/utils/url";

declare global {
  export namespace ExamType {
    export interface ExamDetailData {
      theme_name: string;
      id: string;
      title?: any;
      name: string;
      banner_url: string;
      company_id: string;
      company_name?: any;
      exam_logo: string | null;
      examLogoPath?: string;

      info_id: string;
      year: number;
      category: string;
      time: number;
      total_score: number;
      apply_count: number;
      join_count: number;
      realtime: number;
      examStatus: number;
      start_time?: any;
      end_time?: any;
      is_public: number;
      create_time: string;
      update_time: string;
      is_deleted: number;
      type: number;
      is_publish: number;
      is_mobile: number;
      origin?: any;
      position_ids: string;
      logo_path?: any;
      is_enterprise_logo: number;
      ico_name: string;
      system_logo: string;
      systemLogoPath?: string;
      parent_id?: any;
      online_exam_id?: string;
      subjectsCount: string;
      banner: string;
      isApply: string;
      isFinish: number;
      info: Info;
      positions: Position[];
      subjectNum: Record<number, string>;
      logo: string;
      userData: UserData;
      moni_id?: string;
      on_line_id?: string;
      is_evaluation: number;
      is_realtime: number;
      is_skip_camera: number;
      is_skip_microphone: number;
      is_skip_screen: number;
      is_skip_phone: number;
      is_close_camera: number;
      is_close_microphone: number;
      is_close_screen: number;
      is_close_phone: number;
      cutting_times: number;
      is_copy_question: number;
      is_paste: number;
      is_upload_file: number;
      is_monitor: number;
      ceping_type: number;
      ceping_post: null;
      countNum?: { evaluation: string; linetest: string; major: string };
    }

    export interface Info {
      id: string;
      company: string;
      logoUrl: string;
    }

    export interface Position {
      id: string;
      name: string;
      resume: string;
      city: string;
      info_id: string;
      company_id: string;
      create_time: string;
      update_time: string;
      expire_time: string;
      sort: number;
      is_deleted: number;
      content_offset: number;
      description: string;
      isMultiselect: number;
      isNt: number;
    }

    export interface UserData {
      id: string;
      exam_id: string;
      finish_time: string;
      create_time: string;
      out?: any;
      lastAnswer: number;
    }

    export namespace ExamListType {
      export interface ListData {
        exams: Exam[];
        total: string;
        banners: any[];
        recommend_xyzp: RecommendXyzp[];
      }

      export interface Exam {
        id: number;
        title?: any;
        name: string;
        banner_url: string;
        company_id: number;
        company_name?: any;
        info_id: number;
        year: number;
        category: string;
        time: number;
        total_score: number;
        apply_count: number;
        join_count: number;
        start_time?: any;
        end_time?: any;
        is_public: number;
        create_time: string;
        update_time: string;
        is_deleted: number;
        type: number;
        is_publish: number;
        origin?: any;
        position_ids: string;
        logo_path?: any;
        parent_id?: any;
        subjectsCount: string;
        banner: string;
        isApply: string;
        isFinish: number;
        info: Info;
        logo: string;
        userData?: any;
      }

      export interface RecommendXyzp {
        id: number;
        company: string;
        title: string;
        logoUrl: string;
        positions: Pick<Position, 'id' | 'name' | 'resume'> & 'classify'[];
        infocity: string[];
        isExpired: boolean;
        is_official: number;
        web: string;
        active_time: string;
        expire_time: string;
      }
    }
  }

  export namespace SubjectType {
    export interface Data {
      subject: Subject;
    }

    export interface OrderData {
      subject_order: SubjectOrder[];
    }

    export interface SubSubject {
      id: string;
      is_combine: number;
      combine_id?: any;
      type: number;
      category: number;
      paper_id?: any;
      content: string;
      score: number;
      content_extend?: any;
      subject_name?: string;
      options?: any;
      answers: string;
      explain: string;
      tag: string;
      tag_sub: string;
      company_tag: string;
      year: string;
      origin: string;
      is_deleted: number;
      question_type: number;
      create_time: string;
      optionsArray: any[];
      update_time: string;
      parent: number;
      meta: any;
    }

    export interface Audio {
      url: string;
      times: number;
      index: number;
    }

    export interface Meta {
      audio?: Audio[];
      auto_complete?: string;
      langs?: string[];
      blanks_number?: string[];
    }

    export interface Subject2 {
      id: string;
      content: string;
      type: number;
      subject_name?: string;

      content_extend?: any;
      optionsArray: string[];
      final_score: number;
      current?: number;
      question_type: number;
      subSubjects: SubSubject[];
      meta: Meta;
    }

    export interface Subject {
      id: string;
      exam_id: string;
      subject_id: string;
      create_time: string;
      update_time: string;
      is_show: number;
      ranking: number;
      isMarked: number;
      subject: Subject2;
      final_score: number;
      problem: Problem;
      answer?: any;
    }
    export interface Problem {
      id: string;
      subject_id: string;
      content: string;
      all_header: { name: keyof typeof languagesEnum; header: string }[];
      input_description: string;
      output_description: string;
      samples: { input: string; output: string }[];
      url: string;
      test_case_id: string;
      test_case?: any;
      hint?: any;
      languages: string[];
      time_limit: number;
      memory_limit: number;
      score: number;
      is_deleted: number;
      create_time: string;
      update_time: string;
      test_case_other: string;
      is_auto_complete: number;
      is_tab_notice: number;
      is_self_test: number;
      header: string;
      default_lan: string;
    }

    export interface Subject3 {
      id: string;
      type: number;
      is_combine: number;
      combine_id?: any;
      examCount: number;
    }

    export interface SubjectOrder {
      id: string;
      parent_id?: string;
      type: number;
      sub_type?: number;
      parent: number;
      order_num: number;
      sort: number;
      isAnswered: number;
      isMarked: number;
      subject_id?: string;
      index?: number;
      cepingType?: number;
      is_last?: number;
    }

    export interface AudioDetail {
      id: string;
      grade_id: string;
      exam_id: string;
      subject_id: string;
      user_id: string;
      url: string;
      index: number;
      play_num: number;
      leave_times: number;
    }
  }

  export namespace AnswerType {
    export type AnswerRequest = {
      exam_id: string;
      subject_id: string;
      content: string;
      code_content?: string; //代码答案
      img_content?: string; //图片答案
      language?: string; //编程语言
      type?: 'linetest' | 'major';
    };
  }
}

//试卷列表
export async function getExamList(params: { auth: string; limit?: number; page?: number }) {
  return api<API.Response<ExamType.ExamListType.ListData>>('/exam/index', {
    method: 'GET',
    params,
  });
}

//试卷详情
export async function getExamDetail(params: { id?: string; auth?: string; anid?: string }) {
  return api<API.Response<ExamType.ExamDetailData>>('/exam/show', {
    method: 'GET',
    params,
  });
}

//开始答题
export async function startExam(data: { exam_id?: string; anid: string; ht?; change?: any }) {
  return api<API.Response<ExamType.ExamDetailData>>('/monitor/start-exam', {
    method: 'POST',
    data,
  });
}

//试卷题目详情
export async function getExamOrder(params: { exam_id?: string; subject_id: string }) {
  return api<API.Response<SubjectType.Data>>('/subject/show-new', {
    method: 'GET',
    params,
  });
}

//答题卡 || 题目列表
export async function getOrderList(params: { exam_id?: string }) {
  return api<API.Response<SubjectType.OrderData>>('/subject/order-list', {
    method: 'GET',
    params,
  });
}

//答题
export async function answerQuestion(data: AnswerType.AnswerRequest) {
  return api<API.Response<SubjectType.Data>>(`/answer/answer`, {
    method: 'POST',
    data,
  });
}

//标记题目
export async function markQuestion(data: { exam_id: string; subject_id: string; is_mark: number }) {
  return api<API.Response<SubjectType.Data>>(`/answer/answer`, {
    method: 'POST',
    data,
  });
}

//在线编译
export async function getDebug(data: { src: string; subject_id: string; language: string }) {
  return api<{
    status: number | 'success';
    message: string;
    error_info: string;
    error_line: number;
    test_msg: {
      output_results;
      input_example;
      expected_results;
    };
  }>(`/answer/judge`, {
    method: 'POST',
    data,
  });
}

//获取编程题头文件
export async function getHead() {
  return api<{ status: string; message: string; data }>(`/subject/header-file`, {
    method: 'GET',
  });
}

//获取音频题的播放次数信息
export async function getAudioDetail(data: { subject_id: string; exam_id: string }) {
  return api<API.Response<SubjectType.AudioDetail[]>>(`/subject/get-audio-info`, {
    method: 'POST',
    data,
  });
}

//音频播放次数改变
export async function changeAudioTimes(data: {
  index: number;
  subject_id: string;
  exam_id: string;
}) {
  return api<API.Response>(`/subject/audio-play`, {
    method: 'POST',
    data,
  });
}

//交卷
export async function submitExam(data: { clint?: string; exam_id: string }) {
  return api<API.Response>(`/monitor/finish-exam`, {
    method: 'POST',
    data,
  });
}
